import { Box, createStyles, Grid, IconButton, Theme, Tooltip, Typography } from "@mui/material";
import Dropzone from 'react-dropzone';
// import { CloudUpload } from '@mui/icons-material';
import withStyles from "@mui/styles/withStyles";
import PropTypes from 'prop-types';
import ClearIcon from '@mui/icons-material/Clear';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { fileSizeLimitInMB, pageLimit, wordLimit } from "shared/config";
import { humanFileSize } from "shared/utils";
import { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
interface QualityCheckFileUploadPanelProps {
    documentType: string;
    document: File[];
    onDrop: (file: File[]) => void;
    classes: Record<string, string>;
    disableGlossary?: boolean;
    supportDocTypeOverride?: string[];
}

const supportDocType = ['.docx', '.pptx', '.pdf'];

const styles = (theme: Theme) => createStyles({
    paper: {
        margin: '0 1.5rem 0 1.5rem',
    },
    button: {
        margin: '.8rem 1rem .8rem 0',
    }
    ,
    dropzoneContent: {
        marginTop: '20px',
        textAlign: 'center',
    },
    dropzoneTypography: {
        color: 'black',
    },
    dropzoneIcon: {
        marginTop: '15px',
        color: 'black',
    },
});

const QualityCheckFileUploadPanel = (props: QualityCheckFileUploadPanelProps) => {

    const { classes } = props;
    const { t } = useTranslation();

    const [isDragActive, setIsDragActive] = useState(false);

    const supportDocTypeActive = (props.supportDocTypeOverride === undefined ? supportDocType : props.supportDocTypeOverride);

    const docTranslateHelpDescription = (documentType: string) => {
        let page = pageLimit;
        let word = wordLimit;

    if (documentType === 'bilingual') {
            page = pageLimit * 2; // Bilingual files have double the page limit
            word = wordLimit * 2; // Bilingual files have double the word limit
        }

        return (
            <div>
                <p>{t('upload.limitations')}</p>
                <ul>
                    <li>{t('upload.fileSizeLimit', { size: humanFileSize(fileSizeLimitInMB * 1024 * 1024) })}</li>
                    <li>{t('upload.filePageLimit', { pages: page })}</li>
                    <li>{t('upload.fileWordLimit', { words: word })}</li>
                </ul>
            </div>
        )
    };

    useEffect(() => {
        // Reset drag state when document changes
        if (props.document.length > 0) {
            setIsDragActive(true);
        } else {
            setIsDragActive(false);
        }
    }, [props.document]);

    return (
        <Grid container spacing={1}>
            <Grid item xs={12} style={{ paddingTop: "10px" }}>
                <Typography variant="h6" id="modal-title">
                    {t('upload.title', { type: t(`createJob.documentTypes.${props.documentType}`) })}
                </Typography>
                <Box
                    sx={{
                        border: isDragActive || props.document.length !== 0 ? '2px solid #000' : '1px solid rgba(206, 206, 206, 0.75)',
                        padding: '1.2rem',
                        m: '1rem 0',
                        background: '#F0F0F0',
                        borderRadius: '10px',
                        height: '200px'
                    }}
                >
                    <Dropzone
                        onDrop={props.onDrop}
                        onFileDialogCancel={() => { }}
                        accept={supportDocTypeActive.length > 1 ? supportDocTypeActive.join(',') : supportDocTypeActive[0]}
                        disabled={props.disableGlossary}
                        onDragEnter={() => setIsDragActive(true)}
                        onDragLeave={() => setIsDragActive(false)}
                    >
                        {({ getRootProps, getInputProps }) => (
                            <div {...getRootProps()} className={classes.dropzoneContent}>
                                <input {...getInputProps()} />
                                <Typography
                                    variant="body1"
                                    gutterBottom
                                    align="center"
                                    className={classes.dropzoneTypography}
                                >
                                    {t('upload.dropHere')}
                                </Typography>
                                <Typography
                                    variant="body1"
                                    gutterBottom
                                    align="center"
                                    className={classes.dropzoneTypography}
                                >
                                    {
                                        supportDocTypeActive.length > 1 ?
                                            t('upload.uploadA', { types: `${supportDocTypeActive
                                                .slice(0, -1)
                                                .join(', ')} or ${supportDocTypeActive.slice(-1)}` })
                                            :
                                            t('upload.uploadA', { types: supportDocTypeActive[0] })
                                    }
                                </Typography>
                                <Typography
                                    variant="body1"
                                    gutterBottom
                                    align="center"
                                    className={classes.dropzoneTypography}
                                >
                                    {t('upload.orClick')}
                                </Typography>
                                <Tooltip title={docTranslateHelpDescription(props.documentType)}>
                                    <IconButton
                                        sx={{ marginTop: '10px' }}
                                    >
                                        <HelpOutlineIcon />
                                    </IconButton>
                                </Tooltip>
                            </div>
                        )}
                    </Dropzone>
                </Box>
            </Grid>
            {
                props.document.length !== 0 &&
                <Grid item xs={12} sx={{ display: "flex", alignItems: "center" }}>
                    <AttachFileIcon />
                    <Typography variant="subtitle1">
                        {props.document[0] ? props.document[0].name : ""}
                    </Typography>
                    <IconButton onClick={() => { props.onDrop([] as File[]) }}>
                        <ClearIcon />
                    </IconButton>
                </Grid>
            }
        </Grid >
    )
}

QualityCheckFileUploadPanel.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(QualityCheckFileUploadPanel);